import { Injectable } from '@angular/core';
import { JwtService } from './jwt.service';
import { Router, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})

@Injectable()
export class HasTokenResolver {
  constructor(
    private jwtService: JwtService,
    private router: Router
  ) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    if (this.jwtService.IsAuthUser()) {
      const redirectsTo = route.queryParams["redirectsTo"];
      this.router.navigate(["/dashboard"], redirectsTo ? { queryParams: { redirectsTo } } : undefined);
    }
  }
}

@Injectable()
export class AppRoutingAccess {
  constructor(
    private jwtService: JwtService,
    private router: Router
  ) { }
  resolve(route: ActivatedRouteSnapshot): any {
    if (!this.jwtService.IsAuthUser()) {
      const redirectsTo = route.queryParams["redirectsTo"];
      this.router.navigate(["/login"], redirectsTo ? { queryParams: { redirectsTo } } : undefined);
    }
  }
}
